import { Visual } from 'components/Alpha/cards/cardTypes';

const VISUAL_KINDS: unknown[] = ['table', 'chart'];

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const isFieldList = (value: unknown): boolean =>
  value == null ||
  (Array.isArray(value) && value.every(item => isRecord(item) && typeof item.field === 'string'));

export const toVisual = (value: unknown): Visual | undefined => {
  if (!isRecord(value)) return undefined;
  const valid =
    typeof value.id === 'string' &&
    VISUAL_KINDS.includes(value.kind) &&
    Array.isArray(value.rows) &&
    value.rows.every(isRecord) &&
    isFieldList(value.columns) &&
    isFieldList(value.series);
  return valid ? (value as unknown as Visual) : undefined;
};
